// extracted by mini-css-extract-plugin
module.exports = {"companyLogo":"_3kHm0eu6","companyTitleLink":"_3EDiMvBp","basicInfoContainer":"_20SZ7bUs","basicInfoContainerFull":"_3FzxURlE","basicInfoColumnInputs":"_2xyuuvl_","mainSubtitle":"_3oz2esbK","companyName":"_3hvqm8do","positionName":"_3P6bpdcq","years":"RqeISvu_","description":"_2r2w213E","movedContainer":"-fsYLGyE","addButtonBorder":"_2Eo7KNpd","avatarWrapper":"HanzOAu6"};
    if(module.hot) {
      // 1746735792212
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  